import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './components/PrivacyPolicy';
import AppAds from './components/AppAds';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<PrivacyPolicy />} />
          <Route path="/app-ads.txt" element={<AppAds />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;